import { AbstractControl, ValidationErrors } from '@angular/forms';

export const VISA_REGEX: RegExp = /^[0-9]{16}$/;
export const MASTERCARD_REGEX: RegExp = /^5[1-5][0-9]{14}$/;
export const AMERICAN_EXPRESS_REGEX: RegExp = /^3[47][0-9]{13}$/;

export const EXP_DATE_REGEXP: RegExp =
  /^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/;

export const CVC_REGEX: RegExp = /^[0-9]{3,4}$/;

export const ZIP_CODE_REGEX: RegExp = /^\d{5}(?:[-\s]\d{4})?$/;

export class CreditCardValidators {
  static get number() {
    return (control: AbstractControl): ValidationErrors | null => {
      // Handle mask
      const value = control.value?.split(' ')?.join('');

      // TODO: Accept card numbers with 13-20 digits
      if (/^[0-9]{13,20}$/.test(value)) {
        return null;
      }

      return { creditCartNumber: true };
    };
  }

  static get expDate() {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (EXP_DATE_REGEXP.test(value)) {
        return null;
      }

      return { creditCartExpDate: true };
    };
  }

  static get cvc() {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (CVC_REGEX.test(value)) {
        return null;
      }

      return { creditCartCvc: true };
    };
  }

  static get zipCode() {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (ZIP_CODE_REGEX.test(value)) {
        return null;
      }

      return { creditCartZipCode: true };
    };
  }
}
